<template>
  <div class="container">
    <h1 class="page-title">CORE Loader - Unit Expenditure Budget</h1>
    <div>
      <table class="data-table" id="mytable">
        <thead>
          <tr>
            <th>SN</th>
            <th>Category</th>
            <th>Expenditure</th>
            <th>Description</th>
            <th>January</th>
            <th>January Quantity</th>
            <th>February</th>
            <th>February Quantity</th>
            <th>March</th>
            <th>March Quantity</th>
            <th>April</th>
            <th>April Quantity</th>
            <th>May</th>
            <th>May Quantity</th>
            <th>June</th>
            <th>June Quantity</th>
            <th>July</th>
            <th>July Quantity</th>
            <th>August</th>
            <th>August Quantity</th>
            <th>September</th>
            <th>September Quantity</th>
            <th>October</th>
            <th>October Quantity</th>
            <th>November</th>
            <th>November Quantity</th>
            <th>December</th>
            <th>December Quantity</th>
            <th>Unit</th>
          </tr>
        </thead>
        <tbody :key="tablekey"></tbody>
      </table>
    </div>

    <button
      class="form-button"
      style="background-color: green"
      v-if="!uploadingContent"
      @click.prevent="storeMeeting"
    >
      Submit
    </button>
    <p v-if="uploadingContent">uploading <span class="loader"></span></p>
    <br /><br />

    <lable>Upload CSV File</lable><br />
    <input
      type="file"
      class="bg-red-800 p-2 w-full mt-2 text-gray-200 hover:bg-red-900 border rounded-md"
      @change="handleFileUpload"
    />
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import axios from "axios";
import $ from "jquery";
import "datatables.net";
import Swal from "sweetalert2";

const service = ref("");
const unit = ref("");
const category = ref("");
const chartofaccount = ref("");
const description = ref("");
const january = ref("");
const quantity_january = ref("");
const february = ref("");
const quantity_february = ref("");
const march = ref("");
const quantity_march = ref("");
const april = ref("");
const quantity_april = ref("");
const may = ref("");
const quantity_may = ref("");
const june = ref("");
const quantity_june = ref("");
const july = ref("");
const quantity_july = ref("");
const august = ref("");
const quantity_august = ref("");
const september = ref("");
const quantity_september = ref("");
const october = ref("");
const quantity_october = ref("");
const november = ref("");
const quantity_november = ref("");
const december = ref("");
const quantity_december = ref("");
const form = ref([]);
const updateMode = ref(false);
const id = ref(0);
const csvfile = ref();
const tablekey = ref(0);
const uploadingContent = ref(false);
const url = ref();

const handleFileUpload = async (event) => {
  const file = event.target.files[0];
  csvfile.value = file;
  const formdata = new FormData();
  formdata.append("template", csvfile.value);

  const { status, data } = await axios.post(
    `${url.value}/api/v1/core/upload-services`,
    formdata
  );
  console.log(status, data);

  if (status === 200) {
    data.data.forEach((element) => {
      const formData = {
        category: element["CATEGORY"],
        chartofaccount: element["EXPENDITURE"],
        january: element["JANUARY"],
        quantity_january: element["QUANTITY JANUARY"],
        february: element["FEBRUARY"],
        quantity_february: element["QUANTITY FEBRUARY"],
        march: element["MARCH"],
        quantity_march: element["QUANTITY MARCH"],
        april: element["APRIL"],
        quantity_april: element["QUANTITY APRIL"],
        may: element["MAY"],
        quantity_may: element["QUANTITY MAY"],
        june: element["JUNE"],
        quantity_june: element["QUANTITY JUNE"],
        july: element["JULY"],
        quantity_july: element["QUANTITY JULY"],
        august: element["AUGUST"],
        quantity_august: element["QUANTITY AUGUST"],
        september: element["SEPTEMBER"],
        quantity_september: element["QUANTITY SEPTEMBER"],
        october: element["OCTOBER"],
        quantity_october: element["QUANTITY OCTOBER"],
        november: element["NOVEMBER"],
        quantity_november: element["QUANTITY NOVEMBER"],
        december: element["DECEMBER"],
        quantity_december: element["QUANTITY DECEMBER"],
        year: new Date().getFullYear(),
        description: element["DESCRIPTION"],
        unit: element["UNIT"],
      };

      localStorage.setItem("data", formData);

      form.value.push(formData);
    });

    datatable();
  }
};

const datatable = () => {
  $("#mytable").DataTable({
    paging: true,
    searching: true,
    ordering: true,
    data: form.value,
    columns: [
      { data: null, render: (data, type, row, meta) => meta.row + 1 },
      { data: "category" },
      { data: "chartofaccount" },
      { data: "description" },
      { data: "january" },
      { data: "quantity_january" },
      { data: "february" },
      { data: "quantity_february" },
      { data: "march" },
      { data: "quantity_march" },
      { data: "april" },
      { data: "quantity_april" },
      { data: "may" },
      { data: "quantity_may" },
      { data: "june" },
      { data: "quantity_june" },
      { data: "july" },
      { data: "quantity_july" },
      { data: "august" },
      { data: "quantity_august" },
      { data: "september" },
      { data: "quantity_september" },
      { data: "october" },
      { data: "quantity_october" },
      { data: "november" },
      { data: "quantity_november" },
      { data: "december" },
      { data: "quantity_december" },
      { data: "unit" },
    ],
    // Add more options here as needed
  });
};

const storeMeeting = async () => {
  uploadingContent.value = true;
  const { status } = await axios.post(
    `${url.value}/api/v1/core/save-services?param=unit_expenditure_budget`,
    form.value
  );
  if (status === 200 || status === 201) {
    Swal.fire({
      title: "Success!",
      text: "Data Stored Successfully!",
      icon: "success",
      confirmButtonText: "Ok!",
    });
    uploadingContent.value = false;
  }
};

window.updateData = (index) => {
  updateMode.value = true;
  const data = form.value[index];
  id.value = index;
  service.value = data.service;
  category.value = data.category;
  chartofaccount.value = data.chartofaccount;
  january.value = data.january;
  quantity_january.value = data.quantity_january;
  february.value = data.february;
  quantity_february.value = data.quantity_february;
  march.value = data.march;
  quantity_march.value = data.quantity_march;
  april.value = data.april;
  quantity_april.value = data.quantity_april;
  may.value = data.may;
  quantity_may.value = data.quantity_may;
  june.value = data.june;
  quantity_june.value = data.quantity_june;
  july.value = data.july;
  quantity_july.value = data.quantity_july;
  august.value = data.august;
  quantity_august.value = data.quantity_august;
  september.value = data.september;
  quantity_september.value = data.quantity_september;
  october.value = data.october;
  quantity_october.value = data.quantity_october;
  november.value = data.november;
  quantity_november.value = data.quantity_november;
  december.value = data.december;
  quantity_december.value = data.quantity_december;
  description.value = data.description;
  unit.value = data.unit;
};

const settings = ref();
const getUrl = () => {
  const storedSettings = localStorage.getItem("settings");
  if (storedSettings) {
    settings.value = JSON.parse(storedSettings);
    url.value = settings.value.defaultStates[0].budget;
  }
};

onMounted(() => {
  getUrl();
});
</script>

<style>
.container {
  max-width: 100%;
  margin: 0 auto;
  padding: 20px;
}

.page-title {
  font-size: 24px;
  margin-bottom: 20px;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid black;
}

.data-table th,
.data-table td {
  border: 1px solid black;
  padding: 10px;
  text-align: left;
}

.form-button {
  margin-top: 10px;
  padding: 10px 20px;
  background-color: #007bff;
  color: #fff;
  border: none;
  cursor: pointer;
}

.form-fields {
  margin-top: 20px;
}

.input-field {
  width: 40%;
  padding: 5px;
  margin: 5px 0;
  border: 1px solid #ccc;
}

.loader {
  width: 10px;
  height: 10Zpx;
  border: 2px solid black;
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
